"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailSubscriptionRequirement = void 0;
const student_data_requirement_1 = require("./student-data-requirement");
const studentdomain_1 = require("@studyportals/studentdomain");
const scholarship_requirement_type_1 = require("../types/scholarship-requirement-type");
class EmailSubscriptionRequirement extends student_data_requirement_1.StudentDataRequirement {
    constructor() {
        super(...arguments);
        this.type = scholarship_requirement_type_1.ScholarshipRequirementType.EMAIL_SUBSCRIPTIONS;
    }
    isFulfilled() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.anonymousStudentService)
                return false;
            const data = yield this.anonymousStudentService.getStudentData(this.getRequiredStudentFields());
            return Boolean(data[studentdomain_1.StudentField.EMAILING_FAVOURITES] &&
                data[studentdomain_1.StudentField.EMAILING_OTHER] &&
                data[studentdomain_1.StudentField.EMAILING_SCHOLARSHIPS] &&
                data[studentdomain_1.StudentField.EMAILING_UPDATES]);
        });
    }
    getRequiredStudentFields() {
        return [
            studentdomain_1.StudentField.EMAILING_FAVOURITES,
            studentdomain_1.StudentField.EMAILING_OTHER,
            studentdomain_1.StudentField.EMAILING_SCHOLARSHIPS,
            studentdomain_1.StudentField.EMAILING_UPDATES,
        ];
    }
}
exports.EmailSubscriptionRequirement = EmailSubscriptionRequirement;
